(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').controller('onvio.setup.migrations.fileCabinet.MigrationCreationMainController', migrationCreationCtrl);

    migrationCreationCtrl.$inject = ['$scope', '$rootScope', '$q', '$translate', '$stateParams', '$uibModal', '$compile', '$document',
                                '$location', '$timeout', '$window', 'bmpConfirmationDialog',
                                'resolve.translationsLoaded', 'migrationApps', 'migrationConfig', 'migrationService'];

    function migrationCreationCtrl($scope, $rootScope, $q, $translate, $stateParams, $uibModal, $compile, $document, $location, $timeout, $window,
                              bmpConfirmationDialog, translationsLoaded, migrationApps, migrationConfig, migrationService) {
        /*jshint validthis:true */
        var vm = this;
        $scope.migrationApps = migrationApps;
        $scope.migrationConfig = migrationConfig;   // in order to passs to children's controller
        $scope.appToMigrate = migrationApps.fileCabinet;
        $scope.pathToData = '';
        //$scope.itemSetRefreshDate = 'N/A';
        //$scope.pathToDataUsed = '';
        /*
        $scope.appsMigrateOptions = [];
        for (var i = 0; i < migrationConfig.installedProducts.length; i++) {
            var item = migrationConfig.installedProducts[i];
            var opt = {
                value: item.product,
                name: 'Onvio.Migrations.Product.' + migrationService.normalizeName(item.product)
            };
            $scope.appsMigrateOptions.push(opt);
        }
        */

        $scope.dataPathOptions = [];
        $scope.currentProduct = null;
        $scope.itemSetInfo = {};
        $scope.isPreviousUploadingContinue = false;
        $scope.$watch('appToMigrate', function(newValue) {
            $scope.currentProduct = null;
            for (var i = 0; i < migrationConfig.installedProducts.length; i++) {
                var item = migrationConfig.installedProducts[i];
                if (item.product === newValue) {
                    $scope.currentProduct = item;
                    break;
                }
            }
            vm.updateDataPathOptions();
            $scope.isPreviousUploadingContinue = $scope.isUploadingContinue($scope.itemSetInfo);
        });

        vm.updateDataPathOptions = function() {
            $scope.dataPathOptions.splice(0, $scope.dataPathOptions.length);
            if ( angular.isUndefined($scope.currentProduct) || $scope.currentProduct === null) {
                return;
            }
            var productMeta = $scope.currentProduct.productMeta;
            if ( angular.isUndefined(productMeta) ) {
                return;
            }
            $scope.setRefreshInfoOnProduct(productMeta, $scope.itemSetInfo);
            var metaJson = JSON.parse(productMeta);
            var pathExist = false;
            if ( angular.isDefined(metaJson.dataPaths) ) {
                var paths = metaJson.dataPaths;
                for (var i = 0; i < paths.length; i++) {
                    $scope.dataPathOptions.push(decodeURIComponent(paths[i]));
                    if (angular.isDefined($scope.itemSetInfo.currentDataPath) &&
                        paths[i] === $scope.itemSetInfo.currentDataPath) {
                        pathExist = true;
                    }
                }
            }
            //if (!pathExist && angular.isDefined($scope.itemSetInfo.currentDataPath)) {
            //    $scope.dataPathOptions.push($scope.itemSetInfo.currentDataPath);
            //}
            // set the default data path
            if (angular.isDefined($scope.itemSetInfo.dataPathUsed)) {
                $scope.pathToData = $scope.itemSetInfo.dataPathUsed;
            } else if (angular.isDefined($scope.itemSetInfo.currentDataPath)) {
                $scope.pathToData = $scope.itemSetInfo.currentDataPath;
            }
        };

        $scope.onPreviousDataPath = function() {
            if (angular.isDefined($scope.itemSetInfo.currentDataPath) &&
                $scope.itemSetInfo.currentDataPath === $scope.pathToData) {
                return true;
            }
            return false;
        };

        $scope.setRefreshInfoOnProduct = function(productMeta, itemSetInfo) {
            // preserve \ in the paths
            var metaJson = JSON.parse(productMeta.replace(/\\/g, '\\\\'));
            itemSetInfo.itemSetUploadState = metaJson.itemSetUploadState;
            itemSetInfo.itemSetRefreshDate = metaJson.itemSetRefreshDate;
            itemSetInfo.itemSetUploadTime = metaJson.itemSetUploadTime;
            itemSetInfo.itemSetTotalCount = metaJson.itemSetTotalCount;
            itemSetInfo.currentDataPath = metaJson.currentDataPath;
            itemSetInfo.dataPathUsed = metaJson.dataPathUsed;
        };

        $scope.isUploadingContinue = function(itemSetInfo) {
            if (angular.isUndefined(itemSetInfo.itemSetUploadState)) {
                return false;
            }
            if (angular.isUndefined(itemSetInfo.itemUploadTime)) {
                return false;
            }
            if (itemSetInfo.itemSetUploadState === 'reset' || itemSetInfo.itemSetUploadState === 'loading') {
                var oldDate = new Date(itemSetInfo.itemUploadTime);
                var newDate = new Date();
                var dt = newDate.getTime() - oldDate.getTime();
                var mm = dt / (1000 * 60);
                if (mm < migrationApps.uploadingDeadTimeoutMM) {
                    return true;
                }
            }
            return false;
        };

        $scope.isUploadingDead = function(itemSetInfo) {
            if (angular.isUndefined(itemSetInfo.itemSetUploadState)) {
                return false;
            }
            if (angular.isUndefined(itemSetInfo.itemSetUploadTime)) {
                return false;
            }
            if (itemSetInfo.itemSetUploadState === 'reset' || itemSetInfo.itemSetUploadState === 'loading') {
                var oldDate = new Date(itemSetInfo.itemSetUploadTime);
                var newDate = new Date();
                var dt = newDate.getTime() - oldDate.getTime();
                var mm = dt / (1000 * 60);
                if (mm > migrationApps.uploadingDeadTimeoutMM) {
                    return true;
                }
            }
            return false;
        };

        $scope.availableDrawerList = [];
        $scope.selectedDrawerList = [];
        $scope.selectedGridDataTwo = [];
        $scope.hideNextButton = false;
        $scope.hidePreviousButton = false;
        $scope.migrationDescription = '';
        $scope.drawerListLoaded = false;
        $scope.drawerListLoadedPath = '';
        $scope.isDrawerSelectionVisible = false;

        $scope.screens = {
            appsNetwork:  0,
            drawerSelection: 1,
            confirmation: 2
        };
        $scope.stepDisabled = [false, true, true];
        $scope.step = 0;                // -1 from the step display
        $scope.totalStep = 3;

        $scope.busyLoading = false;
        $scope.loadingFailed = false;

        $scope.cancelNewMigration = function() {
            if( !vm.isAppsNetworkFormAnyDirty() ) {
                $location.url(migrationApps.migrationHomeUrl);
                return;
            }
            bmpConfirmationDialog.open({
                titleText: $translate.instant('Onvio.Migrations.New.CancelTitle'),
                bodyText: $translate.instant('Onvio.Migrations.New.CancelBody'),
                confirmText: $translate.instant('Onvio.Setup.Common.Buttons.Yes'),
                cancelText: $translate.instant('Onvio.Setup.Common.Buttons.No')
            }).then(function() {
                $location.url(migrationApps.migrationHomeUrl);
            });
        };

        $scope.showStartMigrationButton = function() {
            if($scope.step !== $scope.screens.drawerSelection) {
                return false;
            }
            return true;
        };

        $scope.disableStartMigrationButton = function() {
            if($scope.selectedDrawerList.length > 0 && angular.isUndefined($scope.migrationIdCreated)) {
                return false;
            }
            return true;
        };

        $scope.showCancelButton = function() {
            return ($scope.step !== $scope.screens.confirmation)? true : false;
        };

        $scope.onWizardChange = function(step) {
            // -1 from the step display
            $scope.hideNextButton = false;
            $scope.desktopUtilityChecking = false;
            $scope.isDrawerSelectionVisible = false;
            if(step !== $scope.screens.appsNetwork) {
                var valid1 = vm.isDescriptionFormValid();
                var valid2 = vm.isAppsNetworkFormValid();
                if( !valid1 || !valid2 ) {
                    $scope.step = $scope.screens.appsNetwork;
                    return false;
                }
            }
            if(step === $scope.screens.drawerSelection) {
                $scope.hideNextButton = true;
                $scope.isDrawerSelectionVisible = true;
                if ($scope. drawerListLoadedPath !== $scope.pathToData) {
                    $scope.drawerListLoaded = false;
                }
                if( !$scope.drawerListLoaded ) {
                    $rootScope.$broadcast('load-drawers');
                }
                /* else if( !$scope.onPreviousDataPath() ) {
                    $scope.drawerListLoaded = false;
                    $scope.availableDrawerList.splice(0, $scope.availableDrawerList.length);
                    $scope.selectedDrawerList.splice(0, $scope.selectedDrawerList.length);
                    $scope.selectedGridDataTwo.splice(0, $scope.selectedGridDataTwo.length);
                }*/
                $rootScope.$broadcast('drawer-selection-visible');
            }
            if(step === $scope.screens.desktopUtility) {
                vm.checkDesktopUtility();
                $scope.stepDisabled[$scope.screens.drawerSelection] = false;
            }
        };

        $scope.onWizardFinish = function() {
            $location.url(migrationApps.migrationHomeUrl);
        };

        $scope.migrationIdCreated = undefined;
        $scope.startMigration = function() {
            $scope.migrationIdCreated = undefined;
            var migrationInfo = {
                description: $scope.migrationDescription
            };
            if ($scope.appToMigrate ===  migrationApps.fileCabinet) {
                var detail = vm.createFileCabinetMigrationInfo();
                migrationInfo = angular.extend(migrationInfo, detail);
            }
            $scope.busyLoading = true;
            migrationService.createNewMigration(migrationConfig.companyId, migrationConfig.contactId,
                                                $scope.currentProduct.migrationProductId, migrationInfo)
            .then( function(resp) {
                $scope.stepDisabled[$scope.screens.confirmation] = false;
                $scope.stepDisabled[$scope.screens.appsNetwork] = true;
                //$scope.stepDisabled[$scope.screens.desktopUtility] = true;
                $scope.stepDisabled[$scope.screens.drawerSelection] = true;
                //$scope.step = $scope.screens.confirmation;
                $scope.hidePreviousButton = true;
                $scope.migrationIdCreated = resp.migrationId;
                //$scope.utilityNewMigration(migrationId);
                vm.showMigrationCreatedAlert();
            }, function() {
                $scope.step = $scope.screens.drawerSelection;
            })
            .finally(function() {
                $scope.busyLoading = false;
            });
        };

        $scope.migrationCreatedAlerts = [];
        vm.showMigrationCreatedAlert = function() {
            $scope.migrationCreatedAlerts = [];
            var alertType = 'info';
            var alertMsg = '<div>The migration has been created on the server.' +
                           '<br>You need to launch your desktop utility to complete the process!</div>' +
                           '<div><br><button class="btn btn-primary align-center" ng-click="utilityNewMigration()">Launch Utility</button><br></div>';
            $scope.migrationCreatedAlerts.push({
                type: alertType,
                msg: alertMsg,
                closeable: false
            });
        };

        vm.utilityCreationWin = null;
        $scope.utilityNewMigration = function() {
            var url = migrationApps.utilityUrl + 'action=new-migration&migrationId=' + $scope.migrationIdCreated;
            vm.utilityCreationWin = $window.open(url, '_blank');
            $timeout(function() {
                vm.utilityCreationWin.close();
            }, migrationApps.utilityWinTimeout);

            $scope.migrationCreatedAlerts = [];
            $scope.step = $scope.screens.confirmation;
        };

        vm.createFileCabinetMigrationInfo = function() {
            var migrationMeta = {
                dataPath: encodeURIComponent($scope.pathToData)
            };
            var items = [];
            for (var i = 0; i < $scope.selectedDrawerList.length; i++) {
                var drawer = $scope.selectedDrawerList[i];
                var dto = {
                    migrationSetId: drawer.migrationSetId
                };
                items.push(dto);
            }
            return {
                migrationMeta: JSON.stringify(migrationMeta),
                items: items
            };
        };

        vm.isDescriptionFormValid = function() {
            if ( !$scope.migrationDescription || ($scope.migrationDescription.trim().length === 0)) {
                $scope.appsNetworkForm.migrationDescription.$dirty = true;
                return false;
            }
            return true;
        };

        vm.isAppsNetworkFormValid = function() {
            var isValid = true;
            if ( !$scope.appToMigrate || ($scope.appToMigrate.trim().length === 0)) {
                $scope.appsNetworkForm.appToMigrate.$dirty = true;
                isValid = false;
            }
            if ( !$scope.pathToData || ($scope.pathToData.trim().length === 0)) {
                $scope.appsNetworkForm.pathToData.$dirty = true;
                isValid = false;
            }
            return isValid;
        };

        vm.isAppsNetworkFormAllDirty = function() {
            /*
             var dirty = ($scope.appsNetworkForm.migrationDescription.$dirty &&
                          $scope.appsNetworkForm.appToMigrate.$dirty && $scope.appsNetworkForm.pathToData.$dirty);
             return dirty;
             */
            return true;
        };

        vm.isAppsNetworkFormAnyDirty = function() {
             var dirty = ($scope.appsNetworkForm.migrationDescription.$dirty || $scope.appsNetworkForm.pathToData.$dirty);
             return dirty;
        };

        /*
        $scope.disableDesktopUtility = function() {
            if($scope.step === $scope.screens.confirmation) {
                return true;
            }
            var dirty = vm.isAppsNetworkFormAllDirty();
            $scope.stepDisabled[$scope.screens.desktopUtility] = !dirty;
            return !dirty;
        };
        */

        $scope.disableDrawerSelection = function() {
            if($scope.step === $scope.screens.confirmation) {
                return true;
            }
            var dirty = vm.isAppsNetworkFormAllDirty();
            $scope.stepDisabled[$scope.screens.drawerSelection] = !dirty;
            return !dirty;
        };

        /*
        $scope.omtrans = function(text) {
            return $translate.instant('Onvio.Migrations.' + text);
        };
        */

        /*
        $scope.selectFileCabinet = function() {
            if($scope.appToMigrate === migrationApps.fileCabinet) {
                return true;
            }
            return false;
        };
        */
    }

})(window.angular);
